import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { Accident } from "@interfaces/accident.interface";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { LogExport } from "@interfaces/logExport.interface";
import { AccidentService } from "@services/accident.service";
import { ExportLogService } from "@services/exportLog.service";
import { ProtectedGridService } from "@services/protectedGrid.service";
import { SiteService } from "@services/site.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "accidents",
	styleUrls: ["accidents.css"],
	templateUrl: "accidents.html"
})
export class AccidentAdminComponent {
	canExportGrid = false;
	deleteEnabled = true;
	editEnabled = true;
	gridLoading = false;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	itemType = "Accident"
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	items: Accident[] = [];
	sites: any[] = [];
	statuses: any;
	title: string;	

	constructor(private router: Router, private toastService: ToastService, private itemService: AccidentService, private exportLogService: ExportLogService, private protectedGridService: ProtectedGridService, private siteService: SiteService) {
		this.headerPrimaryButtons.push({ icon: "fal fa-plus", method: "addNewItem", text: `New ${this.itemType}` });
		this.getSites();
		this.title = `${this.itemType}s`;
		this.viewRow = this.viewRow.bind(this);
		this.editRow = this.editRow.bind(this);
		this.deleteRow = this.deleteRow.bind(this);
		this.getItems();
		this.checkGridExportPermissions();
	}

	addNewItem() {
		this.router.navigate([`${this.itemUrl}/create`]);
	}
	
	checkGridExportPermissions() {
		this.protectedGridService.canExport("Accidents")
			.subscribe(
				(res: any) => {
					this.canExportGrid = res.response;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}
	
	deleteRow(e: any) {
		const result = confirm("Are you sure you want to delete this item?");
		if(result)
		{
			this.itemService.deleteSingleById(e.row.data.id)
				.subscribe(
					() => {
						this.toastService.success(this.itemType + " deleted!");
						this.getItems();
					},
					(err) => {
						console.log(err);
						this.toastService.error("Something Went Wrong!");
					},
				);
		}
	}

	editRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.id}_edit`]);
	}
	
	getItems() {
		this.gridLoading = true;
		this.itemService.getAll()
			.subscribe(
				(res: any) => {
					this.items = res.response.items;
					this.gridLoading = false;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	getSites() {
		this.siteService.getAll()
			.subscribe(
				(res: any) => this.sites = res.response.items,
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	logExport() {
		const logExport = new LogExport();
		logExport.gridName = "Accidents";
		this.exportLogService.logExport(logExport)
			.subscribe(
				() => console.log("Export Logged"),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
					return false;
				},
			);
	}

	viewRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.id}`]);
	}
}